import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import UpaTracker from '../../../tracking/UpaTracker';
import Translate from '../../../utils/Translate';
import Navigator from '../../../utils/Navigator';
import GhostButton from '../GhostButton/GhostButton';
import bags from '../../../assets/images/bags.svg';
import ticket from '../../../assets/images/ticket.svg';
import './Sidebar.css';

const Sidebar = withRouter(props => (
  <div className="-eva-3-bc-white -eva-3-hide-medium-down  Sidebar">
    <div className="eva-3-row -no-gutter content-outer -eva-3-mt-lg -eva-3-ml-lg -eva-3-mr-lg">
      <div className="col -sm-12 -eva-3-mt-sm -eva-3-tc">
        <div className="col -sm-12 -eva-3-center">
          <img src={`${props.journeys ? ticket : bags}`} alt="ticket" />
          <p className="-eva-3-pt-sm title -lg -eva-3-tc-gray-0">
            {Translate.message(`${props.journeys ? 'Consulta y gestiona tus reservas' : '¡Planeá tu nuevo viaje!'}`)}
          </p>
        </div>
        <div className="col -sm-12 -eva-3-mt-xsm">
          <p className="-fs-1 -eva-3-tc-gray-0">
            {Translate.message(`${props.journeys ? 'En Mis Viajes podrás consultar su estado, ver opciones de cambio, obtener vouchers  y otros servicios.' : 'Aprovechá las ofertas en alojamientos, vuelos, actividades y mucho más'}`)}
          </p>
        </div>
        <div className="col -sm-12 -eva-3-mt-lg -eva-3-mb-xlg">
          <GhostButton
            linkTo={`${props.journeys ? Navigator.bookingsPage : Navigator.flightsPage}`}
            large
            force
            onClick={() => UpaTracker.track(props.journeys ? 'bookings' : 'flights')}
            text={Translate.message(`${props.journeys ? 'Mis viajes' : 'Encontrá tu vuelo'}`)}
          />
        </div>
      </div>
      <div className="col -sm-12 options -eva-3-mt-xsm">
        { props.children }
      </div>
    </div>
  </div>
));

Sidebar.defaultProps = {
  journeys: false,
};

Sidebar.propTypes = {
  children: PropTypes.element.isRequired,
  journeys: PropTypes.bool,
};

export default Sidebar;
